import React from 'react';

// eslint-disable-next-line i18next/no-literal-string
const Home: React.FC = () => <div>Home</div>;

export default Home;
